'use client';

import { LocaleList } from '@@i18n';
import { clx } from '@@lib/clx';
import { useLocale } from 'next-intl';
import Link from 'next-intl/link';

/**
 * Component: LocaleSwitcher
 */
export default function LocaleSwitcher() {
  const currentLocale = useLocale();

  return (
    <ul className="-mb-10 -mt-2 flex flex-wrap justify-center gap-6">
      {LocaleList.map(({ flag, value, hreflang }) => {
        const isActive = currentLocale == value;

        return (
          <li key={value}>
            <Link
              href="/"
              locale={value}
              hrefLang={hreflang}
              prefetch={false}
              scroll={false}
              className={clx('grid place-items-center gap-1 uppercase', { 'pointer-events-none font-bold': isActive })}
            >
              <img className="h-6 w-8 overflow-hidden rounded ring-1 ring-black/60" src={flag.src} alt={value} />
              <small className="text-xs">{value}</small>
            </Link>
          </li>
        );
      })}
    </ul>
  );
}

// import Link from 'next/link';
// import { usePathname as usePathname_ } from 'next/navigation';
// const pathName_ = usePathname_();
// {/* <Link className="uppercase" href={'/' + locale} locale={locale} hrefLang={locale}>
//   {locale}
// </Link> */}
